import { render } from "./Sidebar.vue?vue&type=template&id=18e541a0&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=18e541a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18e541a0"

export default script